import React, {Component} from "react"

class PageHeader extends Component {
  render() {
    return (
    <div className="row wrapper border-bottom white-bg page-heading">
      <div className="col-lg-10">
        <h2>{this.props.pageTitle}</h2>
        {this.props.children}
      </div>
      <div className="col-lg-2">

      </div>
    </div>

    )
  }
}

export default PageHeader



// WEBPACK FOOTER //
// ./src/components/PageHeader.js